import { render, staticRenderFns } from "./gl-pnldim.vue?vue&type=template&id=4e3c5eb9&scoped=true"
import script from "./gl-pnldim.vue?vue&type=script&lang=js"
export * from "./gl-pnldim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c5eb9",
  null
  
)

export default component.exports